import format from 'string-format'

const MESSAGE_ADD = 'MESSAGE_ADD'
const MESSAGE_REMOVE = 'MESSAGE_REMOVE'

const initialState = {
	list: [],
	last_id: 0
}

const actions = {

	add: function ({commit, dispatch}, value) {

		let msg = {}

		if (value.constructor.name.endsWith('Error')) {
			const error = value

			msg = {
				type: 'error',
				html: error.message
			}

			if (error.response) {
				let error_txt = null
				const data = error.response.data
				if (typeof (data) === 'string' || data instanceof String) {
					error_txt = error.response.data.replace("\n", "<BR />")
				} else {
					error_txt =
						data.error ? data.error :
							data.detail ? data.detail :
								JSON.stringify(data)
				}
				msg.html = format("{0}: {1}",
					error.response.status,
					error_txt.replace("\n", "<BR />"))
			} else {
				msg.html = error.toString()
			}
			console.error(error)
		} else {
			msg = value
		}

		commit(MESSAGE_ADD, msg)

		// автоматически удаляем не ошибки после таймаута
		switch (msg.type) {
			case 'success':
			case 'info':
			case 'warning':
				setTimeout(function () {
						dispatch('remove', msg)
						//state.list.splice(state.list.indexOf(msg), 1)
					},
					2000)
		}
	},

	remove: function ({commit}, msg) {
		commit(MESSAGE_REMOVE, msg)
	}

}

const mutations = {

	[MESSAGE_ADD](state, msg) {
		msg.id = state.last_id++
		state.list.push(msg)
	},

	[MESSAGE_REMOVE](state, msg) {
		state.list.splice(state.list.indexOf(msg), 1)
	},
}

const getters = {
	list: function (state) {
		return state.list
	},

	count: function (state) {
		return state.list.length
	},

	visibility: function (state) {
		return state.list.length > 0
	}
}


export default {
	namespaced: true,
	state: initialState,
	actions,
	mutations,
	getters
}